import { render } from "./Pathlist.vue?vue&type=template&id=6cfde59c&scoped=true"
import script from "./Pathlist.vue?vue&type=script&lang=js"
export * from "./Pathlist.vue?vue&type=script&lang=js"

import "./Pathlist.vue?vue&type=style&index=0&id=6cfde59c&scoped=true&lang=scss"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfde59c"]])

export default __exports__